import { useEffect, useState } from "react";

/** Devuelve el valor cuando lleva "delay" ms sin cambiar (p. ej. el texto del buscador). */
export const useDebounce = <T,>(value: T, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
};
